"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.matchResults = exports.kycDocumentTypes = exports.kycStatuses = void 0;
exports.kycStatuses = ['NOT_STARTED', 'IN_PROGRESS', 'PROCESSING', 'COMPLETED', 'FAILED'];
exports.kycDocumentTypes = ['PAN', 'AADHAAR'];
exports.matchResults = ['MATCH', 'MISMATCH', 'SKIPPED'];
//# sourceMappingURL=Kyc.js.map